/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_Expected_ReturnInputs */

const cs_investor_expected_return = /** @type {(inputs: Investor_Expected_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Očekávaný výnos`)
};

const en_investor_expected_return = /** @type {(inputs: Investor_Expected_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected return`)
};

/**
* | output |
* | --- |
* | "Expected return" |
*
* @param {Investor_Expected_ReturnInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_expected_return = /** @type {((inputs?: Investor_Expected_ReturnInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_Expected_ReturnInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_expected_return(inputs)
	return cs_investor_expected_return(inputs)
});